import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as operations from './operations';

import { connectedSelectField } from 'app/components/form/field/select';

function realmsSelectImplementation ( WrappedComponent ) {
    return class extends Component {

        onSearchEvent = ( searchQuery ) => {
            const { search } = this.props;
            return search({
                refs: 0,
                query: {
                    name: `${searchQuery}*`
                }
            }, false);
        };

        map = ( realm ) => ({ key: realm.id, value: realm.id, label: realm.name });

        render( ) {
            const { select, ...rest } = this.props;
            const default_select = {
                map: this.map,
                onSearchEvent: this.onSearchEvent,
                ...select
            };
            return <WrappedComponent
                        select={default_select}
                        placeholder='Search realms by name ...'
                        {...rest}
                    />;
        }
    };
}

const realmMapDispatchToProps =  ( dispatch, ownProps ) => {
    const { blrfKey = 'realms_select' } = ownProps;
    return bindActionCreators(
        {
            search: (query) => operations.search(blrfKey, query),
        }, dispatch);
};

const realmMapStateToProps = ( state, ownProps ) => {
    const { blrfKey = 'realms_select' } = ownProps;
    
    const {
        loading = false,
        query = { refs: 0, page: 1 },
        data = [],
        error = false
    } = state.app.blrf.objects[blrfKey] || state.app.blrf.defaultObject;

    return {
        loading, 
        query, 
        data,
        error: (error !== false ? error && error.message : false)
    }
};

const realmsSelectField = connect(realmMapStateToProps, realmMapDispatchToProps)(realmsSelectImplementation(connectedSelectField()));

export {
    realmsSelectField
};
